// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"34eee54f","453":"e5407da2","455":"4e5f793f"}[chunkId] + ".chunk.js";
};